<template>
  <div class="bg-white rounded-sm text-gray mx-2 my-3">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12">
            <div class="border-b border-gray-200">
              <nav class="flex space-x-6 px-4" aria-label="Tabs">
                <div :class="[(currentRoute === 'roles') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('roles')">
                  <div class="flex">
                    <div>Roles</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'permissions') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('permissions')">
                  <div class="flex">
                    <div>Permission Groups</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'accounts') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('accounts')">
                  <div class="flex">
                    <div>User Roles</div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div class="grid grid-cols-12 gap-4 mt-2">
          <div class="col-span-12">
            <AccountPermissionGroups v-if="currentRoute === 'permissions'"/>
            <AccountRoles v-if="currentRoute === 'roles'"/>
            <PermissionAccounts v-if="currentRoute === 'accounts'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import PermissionGroups from '@/domains/home/services/accounts/views/permissions/PermissionGroups.vue'
import AccountRoles from '@/domains/home/services/accounts/views/permissions/AccountRoles.vue'
import PermissionAccounts from '@/domains/home/services/accounts/views/permissions/PermissionAccounts.vue'

const AccountPermissionGroups = PermissionGroups
const currentRoute = ref<string>('roles')

const select = (route: string) => {
  currentRoute.value = route
}
</script>

